var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"RejectionBlock"}},[_c('div',[_c('h2',[_vm._v("Уважаемый клиент!")]),_c('p',[_vm._v("К сожалению, компания отказала Вам в выдаче займа,"),_c('br'),_vm._v(" повторное обращение возможно через 1 месяц.")])])])
}]

export { render, staticRenderFns }